import React, { useEffect, useState } from 'react';
import { Badge } from '@/components/ui/badge';
import { CheckCircle, Clock } from 'lucide-react';
import { ReAnalysisService } from '@/services/ReAnalysisService';

interface ReAnalysisStatusBadgeProps {
  botId: string;
}

export const ReAnalysisStatusBadge: React.FC<ReAnalysisStatusBadgeProps> = ({ botId }) => {
  const [status, setStatus] = useState<{
    completed: boolean;
    completedAt?: string;
    loading: boolean;
  }>({
    completed: false,
    loading: true
  });

  useEffect(() => {
    const checkStatus = async () => {
      try {
        const result = await ReAnalysisService.checkReAnalysisStatus(botId);
        setStatus({
          completed: result.completed,
          completedAt: result.completedAt,
          loading: false
        });
      } catch (error) {
        console.error('Error checking re-analysis status:', error);
        setStatus({
          completed: false,
          loading: false
        });
      }
    };

    checkStatus();
  }, [botId]);

  if (status.loading) {
    return (
      <Badge variant="secondary" className="flex items-center gap-1">
        <Clock className="h-3 w-3" />
        Checking...
      </Badge>
    );
  }

  if (status.completed) {
    const completedDate = status.completedAt ? new Date(status.completedAt).toLocaleDateString() : 'Unknown';
    return (
      <Badge variant="default" className="flex items-center gap-1">
        <CheckCircle className="h-3 w-3" />
        Completed ({completedDate})
      </Badge>
    );
  }

  return (
    <Badge variant="outline" className="flex items-center gap-1">
      <Clock className="h-3 w-3" />
      Ready
    </Badge>
  );
};